export const CATEGORIES = [
  "HR",
  "Recruiting",
  "Updates",
  "Other"
];
